<template>
  <div>{{ model }}</div>
</template>

<script>
export default {
  name: "date",
  data() {
    return {
      model: null,
      date: {
        startDate: new Date()
      }
    };
  },

  props: ["input", "form", "value"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
